var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144.644,
    height: 16.271,
    viewBox: "0 0 144.644 16.271",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2151",
    "data-name": "Groupe 2151",
    transform: "translate(-53.208 -15.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_graphic_eq_24px",
    d: "M6.254,15.017H7.881V5.254H6.254Zm3.254,3.254h1.627V2H9.508ZM3,11.763H4.627V8.508H3Zm9.763,3.254H14.39V5.254H12.763Zm3.254-6.508v3.254h1.627V8.508Z",
    transform: "translate(50.208 13.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_graphic_eq_24px-2",
    "data-name": "ic_graphic_eq_24px",
    d: "M6.254,15.017H7.881V5.254H6.254Zm3.254,3.254h1.627V2H9.508ZM3,11.763H4.627V8.508H3Zm9.763,3.254H14.39V5.254H12.763Zm3.254-6.508v3.254h1.627V8.508Z",
    transform: "translate(63.208 13.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_graphic_eq_24px-3",
    "data-name": "ic_graphic_eq_24px",
    d: "M6.254,15.017H7.881V5.254H6.254Zm3.254,3.254h1.627V2H9.508ZM3,11.763H4.627V8.508H3Zm9.763,3.254H14.39V5.254H12.763Zm3.254-6.508v3.254h1.627V8.508Z",
    transform: "translate(76.208 13.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_graphic_eq_24px-4",
    "data-name": "ic_graphic_eq_24px",
    d: "M6.254,15.017H7.881V5.254H6.254Zm3.254,3.254h1.627V2H9.508ZM3,11.763H4.627V8.508H3Zm9.763,3.254H14.39V5.254H12.763Zm3.254-6.508v3.254h1.627V8.508Z",
    transform: "translate(89.208 13.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_graphic_eq_24px-5",
    "data-name": "ic_graphic_eq_24px",
    d: "M6.254,15.017H7.881V5.254H6.254Zm3.254,3.254h1.627V2H9.508ZM3,11.763H4.627V8.508H3Zm9.763,3.254H14.39V5.254H12.763Zm3.254-6.508v3.254h1.627V8.508Z",
    transform: "translate(102.208 13.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_graphic_eq_24px-6",
    "data-name": "ic_graphic_eq_24px",
    d: "M6.254,15.017H7.881V5.254H6.254Zm3.254,3.254h1.627V2H9.508ZM3,11.763H4.627V8.508H3Zm9.763,3.254H14.39V5.254H12.763Zm3.254-6.508v3.254h1.627V8.508Z",
    transform: "translate(115.208 13.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_graphic_eq_24px-7",
    "data-name": "ic_graphic_eq_24px",
    d: "M6.254,15.017H7.881V5.254H6.254Zm3.254,3.254h1.627V2H9.508ZM3,11.763H4.627V8.508H3Zm9.763,3.254H14.39V5.254H12.763Zm3.254-6.508v3.254h1.627V8.508Z",
    transform: "translate(128.208 13.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_graphic_eq_24px-8",
    "data-name": "ic_graphic_eq_24px",
    d: "M6.254,15.017H7.881V5.254H6.254Zm3.254,3.254h1.627V2H9.508ZM3,11.763H4.627V8.508H3Zm9.763,3.254H14.39V5.254H12.763Zm3.254-6.508v3.254h1.627V8.508Z",
    transform: "translate(141.208 13.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_graphic_eq_24px-9",
    "data-name": "ic_graphic_eq_24px",
    d: "M6.254,15.017H7.881V5.254H6.254Zm3.254,3.254h1.627V2H9.508ZM3,11.763H4.627V8.508H3Zm9.763,3.254H14.39V5.254H12.763Zm3.254-6.508v3.254h1.627V8.508Z",
    transform: "translate(154.208 13.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_graphic_eq_24px-10",
    "data-name": "ic_graphic_eq_24px",
    d: "M6.254,15.017H7.881V5.254H6.254Zm3.254,3.254h1.627V2H9.508ZM3,11.763H4.627V8.508H3Zm9.763,3.254H14.39V5.254H12.763Zm3.254-6.508v3.254h1.627V8.508Z",
    transform: "translate(167.208 13.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_graphic_eq_24px-11",
    "data-name": "ic_graphic_eq_24px",
    d: "M6.254,15.017H7.881V5.254H6.254Zm3.254,3.254h1.627V2H9.508ZM3,11.763H4.627V8.508H3Zm9.763,3.254H14.39V5.254H12.763Zm3.254-6.508v3.254h1.627V8.508Z",
    transform: "translate(180.208 13.59)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.66e48f9fb723c837b906eed6eddfab73.svg";
export { ForwardRef as ReactComponent };